import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { createHash } from 'crypto';
import theme from './theme';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Hash function to convert string to a consistent index
function hashStringToIndex(str: string, arrayLength: number): number {
  const hash = createHash('md5').update(str).digest('hex');
  const hashSlice = hash.slice(0, 8);
  const int = parseInt(hashSlice, 16) % arrayLength;
  return int;
}

// Function to pick an element from an array based on a string
function pickElementByString<T>(str: string, array: T[]): T {
  const index = hashStringToIndex(str, array.length);
  return array[index];
}

const COLORS = [
  theme.colors.red[200],
  theme.colors.orange[200],
  theme.colors.amber[200],
  theme.colors.yellow[200],
  theme.colors.lime[200],
  theme.colors.green[200],
  theme.colors.emerald[200],
  theme.colors.teal[200],
  theme.colors.cyan[200],
  theme.colors.sky[200],
  theme.colors.blue[200],
  theme.colors.indigo[200],
  theme.colors.purple[200],
  theme.colors.fuchsia[200],
  theme.colors.pink[200],
  theme.colors.rose[200],
];

export function pickColorByString(str: string): string {
  return pickElementByString(str, COLORS);
}
